import { RequireAuth } from "@allergy123/auth-client/react";
import { createBrowserRouter, Outlet } from "react-router";
import { AppShell } from "./shell";
import { AccountPage } from "./pages/Account";
import { AuthCallbackPage, NoAccessPage, SignedOutPage } from "./pages/auth";
import { CheckPage } from "./pages/Check";
import { ClassPage } from "./pages/Class";
import { HomePage } from "./pages/Home";
import { ModulePage } from "./pages/Module";
import { PracticePage } from "./pages/Practice";
import { RecordsPage } from "./pages/Records";
import { SkinTestingProficiencyPage } from "./pages/SkinTestingProficiency";
import { TrainingPage } from "./pages/Training";

/** The three auth routes are the same in every browser app (ADR 0010); everything else is behind RequireAuth. */
export const router = createBrowserRouter([
  { path: "/auth/callback", Component: AuthCallbackPage },
  { path: "/auth/signed-out", Component: SignedOutPage },
  { path: "/no-access", Component: NoAccessPage },
  {
    path: "/",
    element: (
      <RequireAuth fallback={<p className="p-6 text-ink-secondary">Signing you in…</p>}>
        <AppShell>
          <Outlet />
        </AppShell>
      </RequireAuth>
    ),
    children: [
      { index: true, Component: HomePage },
      { path: "training", Component: TrainingPage },
      { path: "training/proficiency/skin-testing", Component: SkinTestingProficiencyPage },
      { path: "training/:section/:module", Component: ModulePage },
      { path: "training/classes/:code", Component: ClassPage },
      { path: "training/checks/:code", Component: CheckPage },
      { path: "records", Component: RecordsPage },
      { path: "practice", Component: PracticePage },
      { path: "account", Component: AccountPage },
    ],
  },
]);
